module.exports = __webpack_public_path__ + "static/media/atp-test-w.67e40e62.png";